import Staycation from './Staycation';

export default Staycation;
